function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "50",
  height: "50",
  viewBox: "-5 -5 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_113_4457)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 50H0V0h50v50zM1.3 48.697h47.397V1.3H1.3v47.397z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.035 43.785h3.192v-3.193h-3.192v3.193zM8.814 34.455c-.775 0-1.373.229-1.796.563v-3.907H4.767v12.673h2.251v-5.739c0-.933.458-1.46 1.303-1.46.846 0 1.284.528 1.284 1.46v5.739h2.253v-6.055c0-2.06-1.408-3.274-3.042-3.274h-.002zM17.915 34.464c-1.97 0-3.413 1.23-3.501 3.008h2.217c.053-.668.563-1.02 1.267-1.02.757 0 1.25.364 1.25 1.109v.615h-1.479c-2.234 0-3.502 1.073-3.502 2.868 0 1.671 1.127 2.92 2.974 2.92.897 0 1.601-.244 2.094-.757v.581h2.13V37.56c0-1.867-1.409-3.098-3.45-3.098v.002zm-.3 7.513c-.773 0-1.216-.387-1.216-.985 0-.686.476-1.056 1.374-1.056h1.372v.615c0 .846-.634 1.426-1.532 1.426h.003zM36.502 34.464a3.007 3.007 0 00-1.954.65 2.746 2.746 0 00-1.811-.65 2.407 2.407 0 00-1.638.58v-.404h-2.216v9.15h2.252V37.77c0-.773.334-1.178.95-1.178.615 0 .933.405.933 1.178v6.019h2.252V37.77c0-.773.334-1.178.95-1.178.615 0 .933.405.933 1.178v6.019h2.252v-6.476c0-1.703-1.217-2.85-2.903-2.85zM23.999 31.112v12.673h2.235V31.112h-2.235z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_113_4457"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h50v50H0z"
})))));